module.exports = "/images/bathrooms.jpg?4a80530db055a2125c9cdd302f314b01";